import * as React from 'react';
import * as PropTypes from 'prop-types';
import { StandardPrivacyPolicyContentUI } from './content/StandardPrivacyPolicyUI';
import { HertzPrivacyPolicyContentUI } from './content/HertzPrivacyPolicyUI';

// NOTE: In future this could be exported from this component if it is needed elsewhere
const HERTZ_TEMPLATE_NAME = 'hertz';

export interface IPrivacyPolicyUIStateProps {
    templateName: string;
    dealerName: string;
}
export interface IPrivacyPolicyUIDispatchProps {
}

export type IPrivacyPolicyUIProps = IPrivacyPolicyUIStateProps & IPrivacyPolicyUIDispatchProps;

const PrivacyPolicyUI: React.ComponentType<IPrivacyPolicyUIProps> = (props: IPrivacyPolicyUIProps) => {
    let PrivacyPolicyContentUI;

    switch (props.templateName) {
        case HERTZ_TEMPLATE_NAME:
            PrivacyPolicyContentUI = HertzPrivacyPolicyContentUI;
            break;

        default:
            PrivacyPolicyContentUI = StandardPrivacyPolicyContentUI;
            break;
    }

    return (
        <div className="Disclaimer-container">
            <PrivacyPolicyContentUI dealerName={props.dealerName} />
        </div>
    );
};

export default PrivacyPolicyUI;
